import moment from "moment";
import { Row, Col } from "react-bootstrap";
const PatientInfoSection = ({ patient, title, showImage = false }) => {
  if (!patient) return null;

  // Calculate age from DOB if available
  const patientAge =
    patient.patient_dob && patient.patient_dob !== ""
      ? moment().diff(moment(patient.patient_dob), "years")
      : "";

  // Define fields to render, reducing conditional repetition
  const fields = [
    { label: "MRN", key: "patient_mrn" },
    { label: "ID No", key: "patient_nationalid" },
    { label: "Birth Date", key: "patient_dob" },
    { label: "Marital Status", key: "maritalstatus" },
    { label: "Gender", key: "gender" },
    { label: "Occupation", key: "occupation" },
    { label: "Religion", key: "religion" },
    { label: "Mobile No", key: "mobileno" },
    { label: "Nationality", key: "nationality" },
  ];

  return (
    <>
      {title && (
        <Row className="mt-3">
          <Col>
            <div className="fs-9 mb-2 text-left">{title}</div>
          </Col>
        </Row>
      )}
      <Row className="text-center mb-4">
        <Col>
          {showImage && (
            <div className="position-relative d-inline-block">
              <img
                src="/test-img.png"
                alt="Patient"
                className="img-fluid rounded-circle border"
                style={{
                  width: "75px",
                  height: "75px",
                  objectFit: "cover",
                  border: "3px solid #2c7be5",
                }}
              />
            </div>
          )}
          <div className="mt-3 text-800 text-capitalize fs-11 fw-bold">
            {patient.patient_firstname || ""} {patient.patient_familyname || ""}
          </div>
          <div className="mt-2 text-muted text-capitalize fs-11">
            {patientAge !== ""
              ? `${patientAge} ${patientAge > 1 ? "Years" : "Year"}`
              : ""}{" "}
            - {patient.gender}
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          {fields.map(
            ({ label, key }) =>
              patient[key] && (
                <InfoRow key={key} label={label} value={patient[key]} />
              )
          )}
        </Col>
      </Row>
    </>
  );
};
export default PatientInfoSection;

const InfoRow = ({ label, value }) => (
  <>
    <Row className="mb-2">
      <Col xs={6} className="text-start fs-11 fw-bold text-900">
        {label}
      </Col>
      <Col xs={6} className="text-end fs-11 fw-500 text-700">
        {value}
      </Col>
    </Row>
    <hr className="mt-1 mb-3" />
  </>
);
